import { themeName } from '@/helpers/getThemeConfig';
import * as buffalobet from './primary.styles.buffalobet';
import * as bet777 from './primary.styles.bet777';

const styleImports: Partial<Record<string, any>> = {
  buffalobet,
  bet777,
};

export const styleImport = styleImports[themeName]?.default;
